
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"154","viewBox":"0 0 154 154","width":"154","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"77","cy":"77","fill":"#1855d1","r":"77"}}),_c('path',{attrs:{"d":"M67.818 97.818v-.545c.06-5.788.667-10.394 1.818-13.818 1.152-3.425 2.788-6.197 4.91-8.319 2.12-2.12 4.666-4.075 7.636-5.863A23.872 23.872 0 0087 65.409a17.186 17.186 0 003.364-5.227c.848-1.97 1.272-4.152 1.272-6.546 0-2.97-.697-5.545-2.09-7.727-1.394-2.182-3.258-3.864-5.591-5.045-2.334-1.182-4.925-1.773-7.773-1.773-2.485 0-4.879.515-7.182 1.545s-4.227 2.652-5.773 4.864c-1.545 2.212-2.44 5.106-2.681 8.682H49.09c.242-5.152 1.576-9.56 4-13.228 2.455-3.666 5.682-6.47 9.682-8.409 4.03-1.939 8.5-2.909 13.409-2.909 5.333 0 9.97 1.061 13.909 3.182 3.97 2.121 7.03 5.03 9.182 8.727 2.182 3.697 3.272 7.91 3.272 12.637 0 3.333-.515 6.348-1.545 9.045a22.285 22.285 0 01-4.364 7.228c-1.878 2.12-4.151 4-6.818 5.636-2.666 1.667-4.803 3.424-6.409 5.273-1.606 1.818-2.773 3.984-3.5 6.5-.727 2.515-1.121 5.651-1.182 9.409v.545zm5.818 26.909c-2.242 0-4.166-.803-5.772-2.409-1.606-1.606-2.41-3.53-2.41-5.773 0-2.242.804-4.166 2.41-5.772 1.606-1.606 3.53-2.409 5.772-2.409 2.243 0 4.167.803 5.773 2.409s2.41 3.53 2.41 5.772a7.708 7.708 0 01-1.137 4.091 8.48 8.48 0 01-2.955 3c-1.212.728-2.575 1.091-4.09 1.091z","fill":"#fff"}})])
          )
        }
      }
    